// -- [WHY copy for the positioning hero — supports <strong> and **bold** via MarkdownLike]

export interface PositioningWhyCopy {
  /** -- Short lines shown above the fold */
  teaser: string[]
  /** -- Extra paragraphs behind “More reasons” */
  details: string[]
  /** -- Closing line; same <strong> / **bold** support */
  closing: string
}

export const POSITIONING_WHY: PositioningWhyCopy = {
  teaser: [
    'Drivible makes **dealership paperwork easier**. Scan to our email, use your own scanners, and **OCR everything** so you can search by RO#, VIN, rego, or client details.',
    'For the biggest win, try **bulk document splitting**: scan up to 200 pages of Repair Orders and we split them into individual docs in seconds.',
  ],
  details: [
    'Each document goes through DocAI. We build Client records, extract key fields, and power **ePayment, eSign and eInvoice**, plus Test Drives and more.',
  ],
  closing:
    "Once you've transitioned to Drivible you should be confident enough to **scan, then shred your documents**.",
}
